import axios from "axios";
import { getStoredToken, clearAuth } from "../auth/storage";

export const SESSION_EXPIRED_EVENT = "backoffice:session-expired";

export const api = axios.create({
  baseURL:
    process.env.REACT_APP_BACKOFFICE_API_URL ||
    process.env.REACT_APP_API_URL ||
    "http://localhost:4000/api",
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuth();
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
    return Promise.reject(error);
  },
);

export function extractErrorMessage(error, fallback = "Erro inesperado") {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.msg ||
    error?.message ||
    fallback
  );
}
